<template>
  <div class="loader-wrapper">
    <div class="image-container">
      <img id="shape" :src="becomeShapeLogo" alt="shape">
      <img id="circle" :src="becomeCircleLogo" alt="circle">
    </div>

    <div v-if="title || subtitle" class="text-wrapper">
      <span v-if="title" class="t3 -t_semi-bold">{{ title }}</span>
      <span v-if="subtitle" class="t3">{{ subtitle }}</span>
    </div>
  </div>
</template>

<script>
import becomeCircleLogo from '@/assets/images/login/become/logo-parts/become-logo-circle.svg';
import becomeShapeLogo from '@/assets/images/login/become/logo-parts/become-logo-shape.svg';

export default {
  name: 'BounceLoader',
  props: {
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      becomeCircleLogo,
      becomeShapeLogo,
    };
  },
};
</script>

<style lang="scss" scoped>
.loader-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  gap: 1rem;

  .text-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }

  .image-container {
    position: relative;
    width: 3.75rem;
    height: 3.75rem;
  }
}

#circle,
#shape {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

#circle {
  animation: pulse 2s ease-in infinite;
}

#shape {
  animation: shrink-and-pulse 2s ease-in infinite;
  z-index: 1;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.9);
  }
}

@keyframes shrink-and-pulse {
  0%, 100% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.8);
  }
}
</style>
